// extracted by mini-css-extract-plugin
module.exports = {"bqBlock":"Banner_bqBlock__8tcsR","bqImage":"Banner_bqImage__3fY-v"};